module.exports = __webpack_public_path__ + "img/load_month_cons.ef95ffb5.svg";